import {
  ContainerCard,
  SubContainerCard,
  DivSubContainerCard,
  SignalYellow,
  Confirm
} from "./style";

import BootonsMap from "../ButtonsMap";

function MpSalesComponent({
  preco,
  setPreco,
  quantidade,
  setQuantidade,
  quantidadeVenda,
  setQuantidadeVenda,
  precoVenda,
  setPrecoVenda,
  totalReceita,
  handleSales
}) {

  return (
    <>
      <ContainerCard>
        {quantidade === 0 ? (
          <SubContainerCard>
            <p style={{
              justifyContent: 'center',
              textAlign: 'center'
            }}>
              Sem estoque para este produto,<br /> negocie uma nova compra.
            </p>
          </SubContainerCard>
        ) : null

        }
        <SubContainerCard>
          <p>
            Estoque <small>{parseFloat(quantidade)?.toFixed(2)}</small>
          </p>
        </SubContainerCard>
        <SubContainerCard>
          <p>
            Custo médio<small>{parseFloat(preco ?? 0 * quantidade)?.toFixed(2)}</small>
          </p>
        </SubContainerCard>
        <SubContainerCard className="column">

          <p>
            Quantidade de venda <input disabled={quantidade === 0} value={quantidadeVenda} onChange={(e) => {
              if (Number(e.target.value) > quantidade) return

              setQuantidadeVenda(e.target.value)
            }} />
          </p>
          <p>
            Preço de venda <input value={precoVenda} onChange={(e) => setPrecoVenda(e.target.value)} />
          </p>
          <p>
            Total de receita de produto <input disabled value={totalReceita} />
          </p>

        </SubContainerCard>
        {/* <SubContainerCard>
            <DivSubContainerCard className="column">
              <p>Marketing </p>
              <img src="./images/sausage_gray.svg" alt="sausage" />
            </DivSubContainerCard>
            <DivSubContainerCard className="column">
              <p>Total Marketing Produto</p>
              <small>D$ 60,00</small>
              <p>Total Marketing Pedido</p>
              <small>R$ 0,00</small>
            </DivSubContainerCard>
          </SubContainerCard> */}
        <SubContainerCard onClick={() => {
          if (quantidade === 0) return
          handleSales()
        }}>
          <p>
            Enviar
          </p>
        </SubContainerCard>
      </ContainerCard>
      <BootonsMap />
    </>
  )
}

export default MpSalesComponent;